"use client";

import React from "react";
import { StyledSection } from "./midPageCta.styles";
import { trackEvent } from '@/lib/track';

interface IMidPageCtaProps {
  headline: string;
  buttonText: string;
  href: string;
  microcopy?: string;
  eventName?: string;
}

export const MidPageCta = ({
  headline,
  buttonText,
  href,
  microcopy,
  eventName,
}: IMidPageCtaProps) => {
  const handleClick = () => {
    if (eventName) trackEvent(eventName);
  };

  return (
    <StyledSection>
      <div className="inner">
        <p className="headline">{headline}</p>
        <a className="cta" href={href} onClick={handleClick}>
          {buttonText}
          <span aria-hidden="true">→</span>
        </a>
        {microcopy && <p className="microcopy">{microcopy}</p>}
      </div>
    </StyledSection>
  );
};
